<template>
  <div>
    <div class="app" v-cloak>
      <keep-alive :include="include" :max="10">
        <router-view class="router" ref="router"></router-view>
      </keep-alive>
    </div>
    <Footer v-if="footer === true"></Footer>
    <Home v-if="home === true && homeShow"></Home>
  </div>
</template>
<script>
function isKeepAlive($route) {
  return $route.meta.keepAlive === undefined || $route.meta.keepAlive;
}

import Footer from "@components/Footer";
import Home from "@components/Home";
import { mapGetters } from "vuex";
import { openShareAll } from "@libs/wechat";
import { getShare } from "@api/public";
import { isWeixin } from "@utils/index";
import { getDepartmentAPI } from "@api/login";
export default {
  data() {
    return {
      transitionName: "fold-right",
      include: isKeepAlive(this.$route) ? [this.$route.name] : [],
      history: [],
      homeShow: false,
    };
  },
  provide() {
    return {
      app: this,
    };
  },
  computed: mapGetters(["footer", "home", "isLogin"]),
  components: {
    Footer,
    Home,
  },
  watch: {
    $route(to, from) {
      const lastPath = this.history[this.history.length - 1] || {},
        { isReplace, isBack } = this.$router;

      if (lastPath.path === to.path) {
        this.transitionName = "fold-right";
        this.history.pop();
      } else {
        this.transitionName = "fold-left";
        if (!isReplace) this.history.push({ path: from.path, name: from.name });
      }
      if (isKeepAlive(to) && to.name !== "Login") {
        !this.include.includes(to.name) && this.include.push(to.name);
      }

      if (isKeepAlive(from) && isBack) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }

      this.$router.isBack = false;
      this.$router.isReplace = false;
    },
  },
  mounted: function () {
    this.setOpenShare();
    console.log(this.$route.path);
    if (this.$route.path !== "/succeed") {
      this.homeShow = true;
    } else {
      this.homeShow = false;
    }
  },
  methods: {
    //判断是否是微信公众号浏览
    setOpenShare: function () {
      if (isWeixin()) {
        if (
          location.href.search('news_detail') < 1
        ) {
          return
        }
        getShare().then((res) => {
          // console.log('如果是微信公众号浏览',res)
          console.log(location.href, '11111')
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img,
          }
          openShareAll(configAppMessage);
        });
      }
    },
  },
};
</script>
<style lang="scss">
.el-input__inner {
  border: none !important;
}

.el-step__title {
  font-size: 0.24rem !important;
}

.el-step__title.is-success {
  color: red !important;
}

.el-step__head.is-success {
  color: red !important;
  border-color: red !important;
}

// .el-input--suffix .el-input__inner {
//   padding-right: 76px !important;
// }

[v-cloak] {
  display: none !important;
}

.router {
  position: absolute;
  width: 100%;
}

.fold-left-enter-active {
  animation-name: fold-left-in;
  animation-duration: 0.5s;
}

.fold-left-leave-active {
  animation-name: fold-left-out;
  animation-duration: 0.5s;
}

@keyframes fold-left-in {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  10% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-left-out {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.fold-right-enter-active {
  animation-name: fold-right-in;
  animation-duration: 0.5s;
}

.fold-right-leave-active {
  animation-name: fold-right-out;
  animation-duration: 0.5s;
}

@keyframes fold-right-in {
  0% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  10% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-right-out {
  0% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    width: 100%;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

.right {
  i {
    display: none !important;
  }

  .el-input__inner {
    text-align: right;
    padding: 0 !important;
  }
}

.el-range-editor.el-input__inner {
  width: 200px !important;
  margin-right: -15px !important;
}

.el-range-separator {
  color: rgb(204, 196, 204) !important;
}

.begin {
  input {
    width: 90px !important;
    text-align: left !important;
    padding: 0 !important;
    // color: #ccc4cc;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.end {
  input {
    width: 90px !important;
    padding: 0 !important;
    text-align: right !important;
    // color: #ccc4cc;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 90px !important;
}

.el-picker-panel {
  left: 10px !important;
}

.el-radio__label {
  display: none !important;
}
</style>
